import React, {useEffect, useRef, useState} from "react";
import{
    Box,
    Stack,
    Typography,
    Switch,
    TextField,
    Autocomplete,
    Chip,
    Collapse,
    Tooltip,
    Button,
} from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";

import { apiFetch } from "../utils/apiFetch";

//*Visit,"controlled component" — the parent owns the data(if on off fingerprintScanner!)
//  visitOn :Boolean
//  onVisitOnchange: (boolean)= void
// visitData: { client: {id,name}|null, amount: string, km: string, parking: string }
// onVisitDataChange: (next visitData) => void

export default function Visit({
    VisitOn,
    VisitOnChange,
    VisitData,
    onVisitDataChange,
}) {
  //! no need to clientName from database 
    // const [clientOptions, setClientOptions] = useState([]);
    // const [loadingClients, setLoadingClients] = useState(false);
    // const [clientsError, setClientsError] = useState("");
    // const fetchedRef = useRef(false);

    // Fixed quick-pick options — no more DB-backed client list.
    // freeSolo on both Autocompletes still lets someone type any custom
    // destination name that isn't in this list.
    const CLIENT_OPTIONS = [
      { id: 1, name: "Home" },
      { id: 2, name: "Company" },
    ];

    // "Home" is a valid starting point but never a real visit destination
const toOptions = CLIENT_OPTIONS.filter(
  (o) => (o.name || "").trim().toLowerCase() !== "home"
);

// To capture From Visit !! 
useEffect(() => {
  if (!VisitOn) return;  // only run when visit turns ON
  console.log("[DEBUG] Visit ON - fetching suggested from...");

  const fetchSuggestedFrom = async () => {
    try {
      const rawBase = localStorage.getItem("saved_sett_api_url") || "";
      const base = rawBase.trim().replace(/\/$/, "");
      const API_BASE = /^https?:\/\//i.test(base) ? base : `https://${base}`;
      const empId = localStorage.getItem("shared_empid");
      const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

      const res = await apiFetch(
        `${API_BASE}/api/visit/today-status?empId=${empId}&date=${today}`
      );
      const data = await res.json();
      console.log("[DEBUG] suggestedFrom respomse:", data);

      if (data.suggestedFrom) {
        onVisitDataChange({
          ...VisitData,
          visitFrom: data.suggestedFrom,
        });
      }
    } catch (err) {
      console.error("Failed to fetch suggested from:", err);
    }
  };

  fetchSuggestedFrom();
}, [VisitOn]);  // fires every time VisitOn changes to true


// runs once, the first time VisitOn turns true — fetches the real
// client list from aci.vclientname via GET /api/visit/clients
// useEffect(() => {
//     if (!VisitOn || fetchedRef.current) return;
//     fetchedRef.current = true;
//     setLoadingClients(true);
//     setClientsError("");

//     const rawBase = localStorage.getItem("saved_sett_api_url") || "http://localhost:5100";

//     fetch(`${rawBase}/api/visit/clients`)
//         .then((res) => res.json())
//         .then((list) => {
//             setClientOptions(Array.isArray(list) ? list : []);
//         })
//         .catch((err) => {
//             console.error("Failed to load clients:", err);
//             setClientOptions([]);
//             setClientsError("Could not load clients. Check your connection.");
//         })
//         .finally(() => {
//             setLoadingClients(false);
//         });
// }, [VisitOn]);

// amount / parking are optional whole-number integers — digits only
const handleIntField = (field) => (e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/[^\d]/g, "");
    onVisitDataChange({ ...VisitData, [field]: cleaned });
};
 
// km is optional and allows ONE decimal point (e.g. "1.7", "1.3")
// strips everything except digits and ".", then collapses any extra
// "." beyond the first so the value always stays a valid number-in-progress
const handleKmField = (e) => {
    const raw = e.target.value;
    let cleaned = raw.replace(/[^\d.]/g, "");
    const firstDot = cleaned.indexOf(".");
    if (firstDot !== -1) {
        cleaned =
            cleaned.slice(0, firstDot + 1) +
            cleaned.slice(firstDot + 1).replace(/\./g, "");
    }
    onVisitDataChange({ ...VisitData, km: cleaned });
};

return (
    // <Box
    //   sx={{
    //     width: "100%",
    //     maxWidth: 560,
    //     borderRadius: 3,
    //     border: "1px solid #b2dfdb",
    //     bgcolor: "rgba(255,255,255,0.95)",
    //     p: 2,
    //     mb: 2,
        
    //   }}
      
    // >
    //   <Stack
    //     direction="row"
    //     alignItems="center"
    //     justifyContent="space-between"
    //   >
    //     <Stack direction="row" alignItems="center" spacing={1}>
    //       <RoomIcon sx={{ color: "#00796b", fontSize: 20 }} />
    //       <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
    //         Visit mode
    //       </Typography>
    //     </Stack>
    //     <Switch
    //       checked={VisitOn}
    //       onChange={(e) => VisitOnChange(e.target.checked)}
    //       color="success"
    //     />
    //   </Stack>

    //   <Collapse in={VisitOn} timeout={200} unmountOnExit>
    //     <Stack spacing={1.5} sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #e0f2f1" }}>
    //       <Chip
    //         icon={<RoomIcon sx={{ fontSize: 16 }} />}
    <Box
      sx={{
        width: "100%",
        maxWidth: 560,
        borderRadius: { xs: 2, sm: 3 },
        border: "1px solid #b2dfdb",
        bgcolor: "rgba(255,255,255,0.95)",
        p: { xs: 1.25, sm: 2 },
        mb: { xs: 1.5, sm: 2 },
      }}
    >
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <RoomIcon sx={{ color: "#00796b", fontSize: { xs: 18, sm: 20 } }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
          Visit mode
        </Typography>
      </Stack>
      <Switch
        checked={VisitOn}
        onChange={(e) => VisitOnChange(e.target.checked)}
        color="success"
        size="small"
      />
    </Stack>

      <Collapse in={VisitOn} timeout={200} unmountOnExit>
        <Stack spacing={1.5} sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #e0f2f1" }}>
          <Chip
            icon={<RoomIcon sx={{ fontSize: 16 }} />}
            label="Visiting a client"
            size="small"
            sx={{
              alignSelf: "flex-start",
              fontWeight: 700,
              bgcolor: "#e3f2fd",
              color: "#0c447c",
            }}
          />

          {/* {clientsError && (
            <Typography variant="caption" sx={{ color: "error.main" }}>
              {clientsError}
            </Typography>
          )} */}
  
           {/* From → To visit fields */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
          {/* From client */}
          <Autocomplete
            sx={{ width: "100%" }}
            options={CLIENT_OPTIONS}
            //loading={loadingClients}
            freeSolo
            value={VisitData.visitFrom || ""}
            onChange={(_, newVal) => {
              // newVal can be a string (free text) or an option object ({name, id})
              const name = typeof newVal === "string" ? newVal : (newVal?.name || "");
              onVisitDataChange({ ...VisitData, visitFrom: name });
            }}
            onInputChange={(_, newInputValue) => {
              // fires as the person types — keeps VisitData in sync even before
              // they blur/select, so a typed name that never matches a real
              // option is still captured correctly
              onVisitDataChange({ ...VisitData, visitFrom: newInputValue });
            }}
            getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt?.name || "")}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            componentsProps={{ popper: { placement: "top" } }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="From"
                required
                placeholder="Select or type a Name..."
                size="small"
              />
            )}
          />

          {/* To client */}
          <Autocomplete
            sx={{ width: "100%" }}
            options={toOptions }
            //loading={loadingClients}
            freeSolo
            value={VisitData.visitTo || ""}
            onChange={(_, newVal) => {
              const name = typeof newVal === "string" ? newVal : (newVal?.name || "");
              onVisitDataChange({ ...VisitData, visitTo: name });
            }}
            onInputChange={(_, newInputValue) => {
              onVisitDataChange({ ...VisitData, visitTo: newInputValue });
            }}
            getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt?.name || "")}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            componentsProps={{ popper: { placement: "top" } }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="To"
                required
                placeholder="Select or type a Name..."
                size="small"
              />
            )}
          />
            {/* From client
            <Autocomplete
            sx={{ width: "100%" }}
              options={clientOptions}
              loading={loadingClients}
              value={clientOptions.find(o => o.name === VisitData.visitFrom) || null}
              onChange={(_, newVal) => {
                onVisitDataChange({ ...VisitData, visitFrom: newVal?.name || "" });
              }}
              getOptionLabel={(opt) => opt?.name || ""}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              componentsProps={{ popper: { placement: "top" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="From"
                  required
                  placeholder="Select client..."
                  size="small"
                />
              )}
            /> */}

            {/* To client */}
            {/* <Autocomplete
            sx={{ width: "100%" }}
              //Ecxlude the Home from visit to 
              options={clientOptions.filter(o => o.name.trim().toUpperCase() !== "HOME")}
              loading={loadingClients}
              value={clientOptions.find(o => o.name === VisitData.visitTo) || null}
              // onChange={(_, newVal) => {
              //   onVisitDataChange({ ...VisitData, visitTo: newVal?.name || "" });
              // }}
              onChange={(_, newVal) => {
              const toName = newVal?.name || "";
              onVisitDataChange({ ...VisitData, visitTo: toName });
            }}
              getOptionLabel={(opt) => opt?.name || ""}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              componentsProps={{ popper: { placement: "top" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="To"
                  required
                  placeholder="Select client..."
                  size="small"
                />
              )}
            /> */}

          </Stack>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <TextField
              label="Amount (L.L)"
              type="number"
              size="small"
              fullWidth
              value={VisitData.amount}
              onChange={handleIntField("amount")}
              inputProps={{ inputMode: "numeric", min: 0, step:50 }}
              InputProps={{
                endAdornment: (
                  <Typography variant="caption" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                    L.L.
                  </Typography>
                ),
              }}

            />
            <TextField
              label="Kilometrage (Km)"
              type="number"
              size="small"
              fullWidth
              value={VisitData.km}
              onChange={handleKmField}
              inputProps={{ inputMode: "decimal", min: 0, step:0.1 }}
              InputProps={{
                endAdornment: (
                  <Typography variant="caption" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                    Km
                  </Typography>
                ),
              }}
            />
          </Stack>

          <TextField
            label="Parking (L.L)"
            type="number"
            size="small"
            fullWidth
            value={VisitData.parking}
            onChange={handleIntField("parking")}
            inputProps={{ inputMode: "numeric", min: 0, step: 50 }}
            InputProps={{
                endAdornment: (
                  <Typography variant="caption" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                    L.L
                  </Typography>
                ),
              }}
            sx={{ maxWidth: { xs: "100%", sm: 270 } }}
          />
        </Stack>
      </Collapse>
    </Box>
  );
}